module.exports = __webpack_public_path__ + "img/overview15.ffc1285.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/overview15.jpg
// module id = kPUQ
// module chunks = 0